import React, { useState, useEffect } from 'react'
import './FaultSecondPageCustom_Coral.css';

import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';

export default function FaultSecondPageKpis_Coral(props) {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [faultCount, setFaultCount] = useState(0);
    const [alarmCount, setAlarmCount] = useState(0);
    const [DTCCount, setDTCCount] = useState(0);
    const [faultCountDsnt, setFaultCountDsnt] = useState(0);
    const [alarmCountDsnt, setAlarmCountDsnt] = useState(0);
    const [DTCCountDsnt, setDTCCountDsnt] = useState(0);
    const [timeDuration, setTimeDuration] = useState(0);
    const [chasisDetails, setChasisDetails] = useState([]);

    const resFaultCntDsnt = (data) => {
        setFaultCount(data.occ.value)
        setFaultCountDsnt(data.L4_Signal_Name.value)
    };
    const resAlarmCntDsnt = (data) => {
        setAlarmCount(data.occ.value);
        setAlarmCountDsnt(data.L4_Signal_Name.value)
    };
    const resDTCCntDsnt = (data) => {
        setDTCCount(data.occ.value)
        setDTCCountDsnt(data.L4_Signal_Name.value)
    };
    const resTimeDuration = (data) => {
        setTimeDuration(data.ActiveDuration.value)
    };
    const resChasisDetails = (data) => setChasisDetails(data._source);

    useEffect(() => {
        let body = { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num }
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/timeDuration', body: body }, resTimeDuration);
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/chasisDetails', body: body }, resChasisDetails);
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/countDistinctFault', body: body }, resFaultCntDsnt);
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/countDistinctAlarm', body: body }, resAlarmCntDsnt);
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/countDistinctDTC', body: body }, resDTCCntDsnt);
    }, [props])

    function toTime(minutes) {
        var h = Math.floor(minutes / 60);
        var m = minutes % 60;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        return `${h}h ${m}min`
    }

    return (
        <>
            <section className="headBG my-2 p-2">
                <div className="row d-flex align-items-center">
                    <div className="col-md-3"><strong>Chassis No:</strong>{chasisDetails?.vehicleId}</div>
                    <div className="col-md-3"><strong>City:</strong>{chasisDetails?.dlr_org_city}</div>
                    <div className="col-md-3"><strong>LOB:</strong>{chasisDetails?.lob}</div>
                    <div className="col-md-3"><strong>PPL:</strong>{chasisDetails?.ppl}</div>
                </div>
            </section>
            <section className="kpi my-3">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-12 col-lg-12">
                        <div className="row">
                            {/* <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{DTCCountDsnt}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"/assets/img/car_repair_black_24dp 2.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{DTCCount}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>DTC Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-lg-6 col-md-6 col-6">
                                <div className="widget p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{faultCountDsnt}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"/assets/img/EV-Logo-1.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{faultCount}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Fault Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-6">
                                <div className="widget p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="float-end" style={{ paddingLeft: "5px", fontSize: "11px" }}>&nbsp;<b></b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"/assets/img/alarm_on_black_24dp 2.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{toTime(timeDuration)}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Fault Active Time Duration</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{alarmCountDsnt}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"/assets/img/notification_important_black_24dp 1.png"} />
                                        </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{alarmCount}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Alarm Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

